import expiredCertificate from './expired-certificate'
import permitLicenses from './permit-licenses'
import pendingReceivedInvoices from './pending-received-invoices'

export default {
  namespaced: true,
  modules: {
    expiredCertificate,
    permitLicenses,
    pendingReceivedInvoices,
  },
}
